import api from "@shared/services/api";
import theme from "@shared/utils/themeColors";
import { useQuery } from "@tanstack/react-query";
import React from "react";
import Toast3 from "../../../components/Toast3";
import {
  ConnectionsResponse,
  MemberWithConnection,
} from "../types/connection.types";
import { MemberCard } from "./MemberCard";

interface ConnectionsTabProps {
  userId: string;
}

const ConnectionsTab: React.FC<ConnectionsTabProps> = ({ userId }) => {
  const { data, isLoading, error } = useQuery<ConnectionsResponse>({
    queryKey: ["connections", userId],
    queryFn: async () => {
      const response = await api.get<ConnectionsResponse>(
        `/connections/user/${userId}`
      );
      return response.data;
    },
  });

  if (isLoading) {
    return (
      <div className="p-4">
        <div className="animate-pulse">
          <div className={`h-24 ${theme.bg.tertiary} rounded mb-4`}></div>
          <div className={`h-24 ${theme.bg.tertiary} rounded mb-4`}></div>
          <div className={`h-24 ${theme.bg.tertiary} rounded`}></div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="p-4">
        <Toast3
          open={true}
          setOpen={() => {}}
          type="error"
          closable={false}
          className={undefined}
        >
          Error loading connections
        </Toast3>
      </div>
    );
  }

  if (!data?.connections?.length) {
    return (
      <div className="p-4">
        <Toast3
          open={true}
          setOpen={() => {}}
          type="info"
          closable={false}
          className={undefined}
        >
          No connections yet
        </Toast3>
      </div>
    );
  }

  return (
    <div className="p-4">
      <div className="grid grid-cols-12 gap-6">
        {data.connections.map((connection: MemberWithConnection) => (
          <div
            key={connection.id}
            className="col-span-full sm:col-span-6 xl:col-span-3"
          >
            <MemberCard member={connection} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ConnectionsTab;
